import { Col, Container, Card, Spinner, Table } from "react-bootstrap";
import Layout from "../components/Layout";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { getEarnings } from "../redux/slices/account.service";
import pound from '../assets/images/pound.svg';
import pound2 from '../assets/images/pound3.svg';
import list from '../assets/images/list.svg';
import list1 from '../assets/images/list1.svg';
import list3 from '../assets/images/list3.svg';
import list4 from '../assets/images/list4.svg';

import {
    Chart as ChartJS,
    Title,
    LineElement,
    PointElement,
    Tooltip,
    Filler,
    LinearScale,
    CategoryScale
  } from 'chart.js';
import { Line } from "react-chartjs-2";
import formatCurrency from "../utils/currencyFormmter";
import AnalyticCard from "../components/analytics/AnalyticCard";
import Paginator from "../components/table/Paginator";
import RecordFilter from "../components/RecordFilter";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler
);

const Earning = () => {

    const isLoaded = useRef(false)


    const dispatch = useDispatch()

    const [results, setResults] = useState([])
    const [analytics, setAnalytics] = useState({})
    const [loading, setLoading] = useState(false)
    const [payload, setPayload] = useState({page: 1, filter_by: 'date'})
    const [paginationData, setpaginationData] = useState({next: '', prev: ''})


    const groupedData = results.reduce((acc, transaction) => {
        const date = new Date(transaction.date);
        const month = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`; // Format as YYYY-MM
        const type = transaction.transaction_type;
    
        if (!acc[type]) acc[type] = {};
        if (!acc[type][month]) acc[type][month] = 0;
    
        acc[type][month] += transaction.amount;
    
        return acc;
      }, {});
    
    const allMonths = Array.from(
    new Set(results.map((t) => new Date(t.date).toISOString().slice(0, 7)))
    ).sort();

    const datasets = Object.entries(groupedData).map(([type, data], index) => ({
    label: type,
    data: allMonths.map((month) => data[month] || 0), 
    borderColor: `hsl(${index * 60}, 70%, 50%)`,
    backgroundColor: `hsl(${index * 60}, 70%, 80%)`,
    pointBorderColor: `hsl(${index * 60}, 70%, 50%)`,
    pointBackgroundColor: "#fff",
    borderWidth: 2,
    tension: 0.4,
    }));

    const chartData = {
    labels: allMonths,
    datasets,
    };

    const options = {
    responsive: true,
    plugins: {
        legend: { display: true, position: "top" },
        tooltip: { enabled: true },
    },
    scales: {
        x: {
        title: { display: true, text: "Month" },
        },
        y: {
        title: { display: true, text: "Amount" },
        beginAtZero: true,
        },
    },
    };

    useEffect(() => {
        if(!isLoaded.current) {
            loadEarnings()
            isLoaded.current = true
        }
    }, [payload.page])

    const loadEarnings = () =>  {
        setLoading(true)
        dispatch(getEarnings(payload))
        .then((response) => {
            if(response.payload.results) {
                setResults(response.payload.results)
            }
            
            if(response.payload?.analytics) {
                setAnalytics(response.payload.analytics)
            }

            if(response.payload?.next || response.payload?.previous) {
                const data = {
                    next: response.payload?.next,
                    prev: response.payload?.previous,
                }
                setpaginationData(data)
            }
        })
        .finally(() => setLoading(false))
    }

    const handlePagination = (data) => {
        isLoaded.current = false
        setPayload({...payload, page: data})
    }

    const handleInput = (event) => {
        const {name, value} = event.target
        setPayload((prevState)=> ({...prevState,[name]:value}))
    }
 
    return (
        <Layout title="Earnings">
            <Container className="mt-4 px-4 mb-4">
                <div className="mt-4">
                    {
                        loading ? (
                            <div className="page-loader">
                                <Spinner size="lg" variant="primary"/>
                            </div>
                        ) : null
                    }
                    <Col md={12} className="mb-3 mt-3 analytic-row earnings">
                        <AnalyticCard 
                            title="Overall Total Earning"
                            value={analytics?.overall_earnings}
                            icon={pound}
                            showCurrency={true}
                            showBorder={false}
                        />
                        <AnalyticCard 
                            title="Total Gross Earning (withdrawal)"
                            value={analytics?.total_withdrawal_earnings}
                            icon={pound2}
                            showCurrency={true}
                        />
                        <AnalyticCard 
                            title="Total Gross Earning (Paycode)"
                            value={analytics?.total_paycode_generation_earnings}
                            icon={list4}
                            showCurrency={true}
                        />
                        <AnalyticCard 
                            title="Total P2P Earning (P2P)"
                            value={analytics?.total_p2p_earnings}
                            icon={list}
                            showCurrency={true}
                        />
                        <AnalyticCard 
                            title="Total Loyalty Voucher Earnings"
                            value={analytics?.total_loyalty_voucher_earning}
                            icon={list1}
                            showCurrency={true}
                        />
                        <AnalyticCard 
                            title="Total Bank Transfer Earning"
                            value={analytics?.total_bank_transfer_earnings}
                            icon={list3}
                            showCurrency={true}
                        />
                        <AnalyticCard 
                            title="Total FaasPay Earnings"
                            value={analytics?.total_faaspay_earnings}
                            icon={pound}
                            showCurrency={true}
                        />
                        <AnalyticCard 
                            title="Total Subcription Earning"
                            value={analytics?.total_subscription_earnings}
                            icon={pound2}
                            showCurrency={true}
                        />
                        <AnalyticCard 
                            title="Total Bills Payment Earning"
                            value={analytics?.total_bills_payment_earnings}
                            icon={pound2}
                            showCurrency={true}
                        />
                        <AnalyticCard 
                            title="Petty Cash Earning"
                            value={analytics?.total_petty_cash_earnings}
                            icon={pound2}
                            showCurrency={true}
                        />
                        <AnalyticCard 
                            title="Sales Force Earning"
                            value={analytics?.total_sales_force_earnings}
                            icon={pound2}
                            showCurrency={true}
                        />
                    </Col>

                    <Card className="border-0 shadow-sm">
                        <Card.Header className="bg-white border-0">VEND CHART</Card.Header>
                        <Card.Body>
                            <Line options={options} data={chartData} />
                        </Card.Body>
                    </Card>

                    <Col className="mt-4 mb-0">
                        <h5>HISTORY</h5>
                        <div className="w-">
                            <RecordFilter
                                handleInput={handleInput}
                                handleSearchSubmit={ () => loadEarnings() }
                                isDate={true}
                            />
                        </div>
                    </Col>
                    <Card className="border-0 shadow-sm mt-0">
                        <Card.Body>
                            <Table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Transaction Type</th>
                                        <th>Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        results.map((transaction, index) => (
                                            <tr key={index}>
                                                <td>{new Date(transaction.date).toLocaleDateString()}</td>
                                                <td>{transaction.transaction_type}</td>
                                                <td>{formatCurrency(transaction.amount).with_currency}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </Table>
                        </Card.Body>
                        <Card.Footer>
                            {
                                results?.length ? (
                                    <div className="table-responsive mt-2">
                                        <Paginator
                                            next={paginationData.next} 
                                            prev={paginationData.prev}
                                            setCurrentPage={ handlePagination }
                                        />
                                    </div>
                                ) : null
                            }
                        </Card.Footer>
                    </Card>
                </div>
            </Container>
        </Layout>
    );
}

export default Earning;